import Box from '@amzn/awsui-components-react/polaris/box';
import Button from '@amzn/awsui-components-react/polaris/button';
import Modal from '@amzn/awsui-components-react/polaris/modal';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Select } from '@amzn/awsui-components-react';
import { values, size, get, filter } from 'lodash';

const UpdateJobCodesModal = props => {
  const { isVisible, onDismiss, onConfirm, onCancel, items } = props;

  const JOB_CODES_OPTIONS = {
    QUALIFIED: { label: 'Qualified', value: 'Q' },
    NOT_QUALIFIED: { label: 'Non Qualified', value: 'NQ' },
  };

  const initialState = {
    selectedOption: JOB_CODES_OPTIONS.QUALIFIED,
  };

  const [state, setState] = useState(initialState);

  useEffect(() => {
    setState({
      selectedOption: filter(
        JOB_CODES_OPTIONS,
        ({ value }) => value === get(items, [0, 'JobCodeQNQ']),
      )[0],
    });
    // eslint-disable-next-line
  }, [items]);

  const setSelectedOption = selectedOption => {
    setState({ ...state, selectedOption });
  };

  const onCancelHandler = () => {
    onCancel();
    setState(initialState);
  };

  const onConfirmHandler = () => {
    onConfirm(state);
    setState(initialState);
  };

  return (
    <Modal
      onDismiss={onDismiss}
      visible={isVisible}
      closeAriaLabel="Close modal"
      size="medium"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onCancelHandler}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onConfirmHandler}>
              Confirm
            </Button>
          </SpaceBetween>
        </Box>
      }
      header="Update Job codes"
    >
      <SpaceBetween size="l">
        <Box variant="p">
          The information of the {size(items)} selected Job codes will be updated.
        </Box>
        <Grid gridDefinition={[{ colspan: 6 }]}>
          <Box>
            QNQ
            <Select
              selectedOption={state.selectedOption}
              onChange={({ detail }) => setSelectedOption(detail.selectedOption)}
              options={values(JOB_CODES_OPTIONS)}
              selectedAriaLabel="Selected"
            />
          </Box>
        </Grid>
      </SpaceBetween>
    </Modal>
  );
};

UpdateJobCodesModal.propTypes = {
  items: PropTypes.array.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default UpdateJobCodesModal;
